import {
    NAV_ITEM_TYPE_COLLAPSE,
    NAV_ITEM_TYPE_ITEM,
} from 'constants/navigation.constant'
import { USER,ANONYMOUS } from 'constants/roles.constant'

const userNavConfig = [
    {
        key: 'titleFeed',
        path: '/',
        title: 'Title Feed',
        translateKey: 'nav.titleFeed',
        icon: '',
        type: NAV_ITEM_TYPE_ITEM,
        authority: [USER,ANONYMOUS],
        subMenu: [],
    },
    // {
    //     key: 'pulse',
    //     path: '/pulse',
    //     title: 'Pulse',
    //     translateKey: 'nav.pulse',
    //     icon: '',
    //     type: NAV_ITEM_TYPE_ITEM,
    //     authority: [USER],
    //     subMenu: [],
    // },
    // {
    //     key: 'collections',
    //     path: '/collections',
    //     title: 'Collections',
    //     translateKey: 'nav.collections',
    //     icon: '',
    //     type: NAV_ITEM_TYPE_ITEM,
    //     authority: [USER],
    //     subMenu: [],
    // },

    {
        key: 'help',
        path: '',
        title: 'Help',
        translateKey: 'nav.help',
        icon: '',
        type: NAV_ITEM_TYPE_COLLAPSE,
        authority: [USER,ANONYMOUS],
        subMenu: [
            {
                key: 'nav.contactUs',
                path: 'https://www.disco.info/contact',
                target: '_blank',
                title: 'Contact Us',
                translateKey: 'nav.contactUs',
                icon: '',
                type: NAV_ITEM_TYPE_ITEM,
                authority: [USER,ANONYMOUS],
                subMenu: [],
            },
            {
                key: 'nav.api',
                path: 'https://www.disco.info/DiscoFeedsApi',
                title: 'API docs',
                translateKey: 'nav.apiDocs',
                icon: '',
                type: NAV_ITEM_TYPE_ITEM,
                authority: [USER,ANONYMOUS],
                subMenu: [],
            },
        ],
    },
]

export default userNavConfig
